module.exports = __webpack_public_path__ + "static/img/06.27f0e23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/06.jpg
// module id = 355
// module chunks = 1